export const OPEN_CONTACT_US_MODAL = 'MODALS/OPEN_CONTACT_US';
export const CLOSE_CONTACT_US_MODAL = 'MODALS/CLOSE_CONTACT_US';

export const TOGGLE_TERMS_OF_SERVICES_MODAL = 'MODALS/TOGGLE_TERMS_OF_SERVICES';

export const TOGGLE_FORGOT_PASSWORD_MODAL =
  'MODALS/TOGGLE_FORGOT_PASSWORD_MODAL';

export const TOGGLE_TUTORIAL_MODAL = 'MODALS/TOGGLE_TUTORIAL_MODAL';



// WEBPACK FOOTER //
// ./src/store/modules/modals/types.js